export default __webpack_public_path__ + "static/media/logo.a00aefe5.png";